
import React, { useContext } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import {useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../authmanager/authcontext';
import { BASE_URL } from '../utils/utils';
const GOOGLE_CLIENT_ID = '1056611449567-kf18a7go0blmtm94vi9uqmo9ai00ahnc.apps.googleusercontent.com';

// const GoogleAuthorLoginButton = () => {
//     const { handleLogin } = useContext(AuthContext);
//     const navigate = useNavigate();
  
//     const handleGoogleLogin = async (response) => {
//       console.log(response.credential);
//       try {
//         const res = await axios.post(`${BASE_URL}/accounts/dj-rest-auth/google/`, {
//           clientId: GOOGLE_CLIENT_ID,
//           access_token: response.credential,
//           author: true,
//         });
//         console.log('User authenticated successfully:', res.data);
//         const { access, refresh, author_or_not } = res.data;
//         handleLogin(access, refresh, author_or_not);
//         navigate('/home');
//         // Store JWT tokens in local storage or state
//       } catch (error) {
//         console.error('Error authenticating with Google:', error);
//       }
//     };
  
//     return (
//       <GoogleLogin
//         clientId={GOOGLE_CLIENT_ID} // Replace with your actual client ID
//         onSuccess={handleGoogleLogin}
//         onError={() => console.log('Login Failed')}
//         buttonText="Continue with Google" // New button text
//       />
//     );
//   };
const GoogleLoginButton = () => {
    const { handleLogin } = useContext(AuthContext);
    const navigate = useNavigate()
    const handleGoogleLogin = async (response) => {
        console.log(response.credential)
        try {
            const res = await axios.post(`${BASE_URL}/accounts/dj-rest-auth/google/`, {
                clientId: GOOGLE_CLIENT_ID,
                access_token:response.credential
            });
            console.log('User authenticated successfully:', res.data);
            const { access, refresh, author_or_not } = res.data;
            handleLogin(access, refresh, author_or_not);
            navigate('/home')
            // Store JWT tokens in local storage or state
        } catch (error) {
            console.error('Error authenticating with Google:', error);
        }
    };

    return (
        <GoogleLogin
            onSuccess={handleGoogleLogin}
            buttonText="Continue with Google"
            onError={() => {
                console.log('Login Failed');
            }}
        />
    );
};


export default GoogleLoginButton ; // Named export
// export {GoogleAuthorLoginButton};